export const dashboard = {
  main: "Dashboard",
};
